import BirlExerciseWeightMap from 'shared/birl/exercises/WeightMap'
import BirlExerciseEntriesIndex from 'shared/birl/exercise_entries/Index'
import DodoneContext from 'app/dodones/Context';
import DodoneFinishButton from 'app/dodones/shared/FinishButton';
import DodoneGenericStats from 'app/dodones/generic/Stats'
import DodoneNextLink from 'app/dodones/shared/NextLink';
import DodoneStartButton from 'app/dodones/shared/StartButton';
import DodonesList from 'app/dodones/list/Index'
import HeaderContext from 'app/HeaderContext';
import LoadingScreen from 'app/components/LoadingScreen'
import NumberPicker from 'app/inputs/NumberPicker'
import React from "react"

import update from 'immutability-helper'
import useBirlExerciseQuery from 'generated/api/birl/exercises/useBirlExerciseQuery'
import { format } from 'date-fns';
import { useState, useCallback, useContext, useEffect, useMemo } from "react"
import Chronometer from 'app/components/Chronometer'

const StartedBirlExercise = ({ birlExercise, series, setSeries }) => {
  const { dodone, updateDodone } = useContext(DodoneContext)
  const [serieSetAt, setSerieSetAt] = useState(dodone.updatedAt)

  const setSerieReps = useCallback((index, n) => {
    const updatedSeries = update(series, { [index]: { reps: { $set: n }}})
    setSeries(updatedSeries)
    setSerieSetAt(new Date)
    const updatedLog = update(dodone.log, { series: { $set: updatedSeries }})
    updateDodone.mutate({ attributes: { log: updatedLog }, skipRefetch: true })
  })

  const up = useCallback((e, props) => {
    const index = props.index
    setSerieReps(index, series[index].reps + 1)
  })

  const down = useCallback((e, props) => {
    const index = props.index
    setSerieReps(index, Math.max(series[index].reps - 1, 0))
  })

  const addSerie = useCallback(() => {
    const updatedSeries = update(series, {
      $push: [series[series.length - 1]]
    })

    setSeries(updatedSeries)
  })

  const removeSerie = useCallback((index) => {
    const updatedSeries = update(series, {
      $splice: [[index, 1]]
    })

    setSeries(updatedSeries)
  })

  const weightSignature = useMemo(() => {
    return dodone.log.series.map((serie) => {
      return serie.weight || ''
    }).join('/')
  }, [dodone, birlExercise])

  return <>
           <BirlExerciseEntriesIndex exerciseId={ dodone.dodoable.settings.exerciseId } weightSignature={ weightSignature } />
           <div className="frow gap-1 mb-d">
             {
               Object.entries(series).map(([index, serie]) => {
                 const weightDisplay = isNaN(serie.weight) ? '?' : `${serie.weight}kg`

                 return <div key={ index } className="flex-1 fcol">
                          <NumberPicker up={ up } down={ down } index={ index }>
                            <div className="gray-transparent-box pt-2 rounded">
                              <div className="text-lg">{ weightDisplay } </div>
                              <div className="frow items-center gap-2 justify-center">
                                <div className="text-2xl">
                                  {
                                    serie.reps
                                  }
                                </div>
                                reps
                              </div>
                            </div>
                          </NumberPicker>
                        </div>
               })
             }
           </div>
           { dodone.isOngoing && <Chronometer startedAt={ serieSetAt } /> }
         </>
}

export default () => {
  const { setText } = useContext(HeaderContext);
  const { dodone } = useContext(DodoneContext);
  const { isPending, data: { birlExercise } = {} } = useBirlExerciseQuery({ birlExerciseId: dodone.dodoable.settings.exerciseId })

  useEffect(() => {
    setText(dodone.dodoable.name)
  }, [dodone.id]);

  const [series, setSeries] = useState([]);

  useEffect(() => {
    if(!birlExercise?.weightMap || !dodone?.log || !dodone?.log?.series) return

    setSeries(dodone.log.series.map((serie) => {
      return { ...serie, weight: birlExercise.weightMap[serie.weightLabel - 1].weight || 0 }
    }))
  }, [dodone?.log, birlExercise?.weightMap])

  const showStartButton = !dodone.isStarted && birlExercise && !birlExercise.isMissingWeightMap
  const showFinishButton = dodone.isStarted && !dodone.isFinished

  if(isPending)
    return <LoadingScreen />

  return <div className={ clsx('flex-1 fcol', { 'justify-center': birlExercise.isMissingWeightMap }) }>
           { dodone.isFinished && <div className="mb-d"><DodoneGenericStats dodone = { dodone } /></div> }
           <BirlExerciseWeightMap birlExercise={ birlExercise } />
           {
             !birlExercise.isMissingWeightMap &&
               <div className="flex-1 fcol">
                 { dodone.isStarted && <StartedBirlExercise birlExercise={ birlExercise } series={ series } setSeries={ setSeries } /> }
               </div>
           }
           { showStartButton && <DodoneStartButton text="Start" /> }
           { showFinishButton && <DodoneFinishButton /> }
           { dodone.isClosed && <DodoneNextLink currentDodoneId = { dodone.id } /> }
         </div>
};
